import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9 .667A8.336 8.336 0 00.667 9c0 4.6 3.733 8.334 8.333 8.334S17.333 13.6 17.333 9 13.6.667 9 .667zm0 15A6.676 6.676 0 012.333 9 6.676 6.676 0 019 2.334 6.676 6.676 0 0115.667 9 6.676 6.676 0 019 15.667zm-.833-3.333h1.666V14H8.167v-1.666zm1.341-8.3a3.335 3.335 0 00-3.691 2.325.756.756 0 00.725.975h.166c.342 0 .617-.242.734-.559A1.668 1.668 0 019.358 5.71c.792.166 1.375.941 1.309 1.75-.084 1.116-1.35 1.358-2.042 2.4 0 .008-.008.008-.008.016-.009.017-.017.025-.025.042-.075.125-.15.267-.209.417-.008.025-.025.041-.033.066-.008.017-.008.034-.017.059-.1.283-.166.625-.166 1.041h1.666c0-.35.092-.641.234-.891.016-.025.025-.05.041-.075.067-.117.15-.225.234-.325.008-.009.016-.025.025-.034.083-.1.175-.191.275-.283.8-.758 1.883-1.375 1.658-2.967-.2-1.45-1.342-2.675-2.792-2.891z",
      fill: "#333"
    }
  )
);
export {
  l as default
};
